/* ==========================================================================
   Article Index Translations (Metadata: Title, Category, Excerpt)
   ========================================================================== */

import cs from './articles/articles_cs.json';
import en from './articles/articles_en.json';
import de from './articles/articles_de.json';
import es from './articles/articles_es.json';
import pt from './articles/articles_pt.json';
import ar from './articles/articles_ar.json';
import it from './articles/articles_it.json';

function extractIndex(dict) {
  const out = {};
  for (const [k, v] of Object.entries(dict || {})) {
    out[k] = {
      title: v.title,
      category: v.category,
      excerpt: v.excerpt,
      date: v.date
    };
  }
  return out;
}

export const articleIndexTranslations = {
  cs: extractIndex(cs),
  en: extractIndex(en),
  de: extractIndex(de),
  es: extractIndex(es),
  pt: extractIndex(pt),
  ar: extractIndex(ar),
  it: extractIndex(it)
};
